var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-config-provider',{attrs:{"locale":_vm.zhCN}},[_c('div',{attrs:{"id":"app"}},[(_vm.timeCorrect)?_c('div',[_c('router-view',{key:_vm.$route.fullPath}),_c('Fade')],1):_c('div',[_c('TimeTips',{on:{"reload":_vm.reload}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }